import { render, staticRenderFns } from "./WdmAndParameterStyle.vue?vue&type=template&id=6435f4f7"
import script from "./WdmAndParameterStyle.vue?vue&type=script&lang=js"
export * from "./WdmAndParameterStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports